<template>
  <div>
    <div class="ps-4">
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="CART">
      </section-header>
    </div>

    <v-data-table :calculate-widths="true"
                  no-data-text="Aucune donnée"
                  :headers="headers"
                  :items="bankLogs"
                  :items-per-page="-1"
                  :height="500"
                  class="white"
                  disable-pagination
                  fixed-header
                  hide-default-footer
                  mobile-breakpoint="100">
      <template v-slot:[`item.dateReleve`]="{ item }">
        {{ formatDate(item.dateReleve) }}
      </template>
      <template v-slot:[`item.dateOperation`]="{ item }">
        {{ formatDate(item.dateOperation) }}
      </template>
      <template v-slot:[`item.dateValeur`]="{ item }">
        {{ formatDate(item.dateValeur) }}
      </template>
    </v-data-table>
  </div>

</template>

<script lang="ts">
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import BankLog, { BankDay } from '@/generated/classes/BankLog';
  import Files, { DownloadData } from '@/generated/classes/Files';
  import { getBlob } from '@/framework/files/helpers/FileTypes';
  import { defineComponent, type PropType } from "vue";
  import type Bank from '@/generated/classes/Bank';
  import { DateFormat } from "@/framework/base/helpers/DateFormat";

  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton
    },
    props: {
      hideTitle: {
        type: Boolean
      },
      extended: {
        type: Boolean
      },
      dialog: {
        type: Boolean
      },
      bankLog: {
        type: Object as PropType<BankDay>,
        required: true
      }
    },
    data() {
      const mBankLogs: BankLog[] = [];

      return {
        canExport: false,
        exportLoading: false,
        dialogOpen: false,
        headers: [
          { title: 'Date relévé', key: 'dateReleve', sortable: true },
          { title: 'Montant', key: 'montant', sortable: true },
          { title: 'Clé de banque', key: 'bankId', sortable: true },
          { title: 'Pièce', key: 'piece', sortable: true },
          { title: 'ligne', key: 'ligne', sortable: true },
          { title: 'Label', key: 'label', sortable: true },
          { title: 'Rapprochement', key: 'rapprochementLabel', sortable: true }
        ],
        sectionName: Sections.BANK_DETAIL,
        mBankLogs,
        mPeriod: new Date()
      };
    },
    computed: {
      saveLabel() {
        return RessourceFwkButton(FwkButtons.EXPORTER).label;
      },
      errorTxt() {
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },
      ressource() {
        return RessourceGenSection(GenSection.BANK_DETAIL);
      },
      bankLogs(): BankLog[] {
        const period = new Date(this.bankLog.dateReleve);
        if (period.getDate() != this.mPeriod.getDate()) {
          this.mPeriod = period;
          this.loadBankDetails();
        }
        return this.mBankLogs;
      }
    },
    methods: {
      loadBankDetails() {
        BankLog.DayDetails(this.bankLog).then((res) => {
          this.mBankLogs = res;
        })
      },
      formatDate(value: string): string {
        return DateFormat.toEdit(value);
      },
      setExtended(extended: Extended): void {
        this.$emit('extended', extended);
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
      openDialog() {
        this.dialogOpen = true;
      }
    }
  })

</script>
